const wisdomWorK =()=>import('@/page/wisdomWorK')
const wisdomMain = ()=>import('@/page/wisdom/wisdomMain')
const baseStructure = ()=>import('@/page/wisdom/baseStructure')
const coreStructure = ()=>import('@/page/wisdom/coreStructure')
const wisdomDetail = ()=>import('@/page/wisdom/wisdomDetail')
const correctDetail = ()=>import('@/page/wisdom/correctDetail')
const publishWork = ()=>import('@/page/wisdom/publishWork')
const scoreDetail = ()=>import('@/page/wisdom/scoreDetail')
const EssayDetail = ()=>import('@/page/wisdom/EssayDetail')
const stuAnswer = ()=>import('@/page/wisdom/stuAnswer')
const wisdomMainold = ()=>import('@/page/wisdom/wisdomMainold')

export default{
	path:'/wisdomWorK',
	component:wisdomWorK,
	children:[
   {
   	path:'wisdomMain',
   	name:'wisdomMain',
   	component:wisdomMain,
	},{
	path:'baseStructure',
	name:'baseStructure',
	component:baseStructure,
	},{
	path:'coreStructure',
	name:'coreStructure',
	component:coreStructure,
	},{
   	path:'wisdomDetail',
   	name:'wisdomDetail',
   	component:wisdomDetail,
   },{
   	path:'correctDetail',
   	name:'correctDetail',
   	component:correctDetail,
   },{
   	path:'publishWork',
   	name:'publishWork',
   	component:publishWork,
   },{
   	path:'scoreDetail',
   	name:'scoreDetail',
   	component:scoreDetail,
   },{
   	path:'EssayDetail',
   	name:'EssayDetail',
   	component:EssayDetail,
   },{
   	path:'stuAnswer',
   	name:'stuAnswer',
   	component:stuAnswer,
   },{
   	path:'wisdomMainold',
   	name:'wisdomMainold',
   	component:wisdomMainold,
   }
	]

}



// WEBPACK FOOTER //
// ./src/router/wisdom.js